import React from 'react';
import './spinner.css';

const Spinner = () => (
  <div className='spinner'>
    <div></div>
    <div></div>
  </div>
);

export default Spinner;
